var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDesc12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95054 4.72871L6.53319 3.31137L5.66777 2.44153C5.3013 2.07505 4.70522 2.07505 4.33874 2.44153L2.05156 4.72871C1.75131 5.02896 1.96767 5.54114 2.38713 5.54114H4.86417H7.61497C8.03885 5.54114 8.25079 5.02896 7.95054 4.72871Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61474 7.79167H4.8628H2.38472C1.96067 7.79167 1.74864 8.30407 2.04901 8.60444L4.33714 10.8926C4.70378 11.2592 5.3001 11.2592 5.66673 10.8926L6.53693 10.0224L7.95487 8.60444C8.25082 8.30407 8.03879 7.79167 7.61474 7.79167Z",
    fill: "#FD8A24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc12);
export default __webpack_public_path__ + "static/media/sort-desc-12.5072fe942b143a192a215aacb0ac07a9.svg";
export { ForwardRef as ReactComponent };